import { ExamCenterProctorRequestType } from '@exam-center/graphql';
import { z } from 'zod';

export const ProctorRequestListFilterFormSchema = z.object({
  proctorType: z
    .object({
      label: z.string(),
      value: z.nativeEnum(ExamCenterProctorRequestType),
    })
    .array(),
});

export type ProctorRequestListFilterFormInput = z.infer<typeof ProctorRequestListFilterFormSchema>;
